const fieldController = {
    props: {
        dataContainer: {
            required: false,
            default: null
        },
        controllerName: {
            required: false
        },
        dataToBind: {
            required: false
        },
        bindingForView: {
            required: false,
            default: false
        },
        autoBind: {
            required: false,
            default: true
        }
    },
    data() {
        return {
            fields: {},
            dataModel: {},
            validData: true
        }
    },
    beforeMount() {
        this.$on('registerField', (params) => {
            this.registerField(params);
        });

        this.$on('updateFieldValue', (params) => {
            this.updateFieldValue(params);
        });

        this.$on('setfieldsErrorMessage', (params) => {
            this.setfieldsErrorMessage(params);
        });

        if (this.dataContainer) {
            this.dataContainer.$emit('registerController', {
                controller: this
            });
        }
    },
    mounted() {
        if (this.dataToBind && this.autoBind) {
            this.bindController()
        }
    },
    methods: {
        bindFieldWFromData(fieldName, bindForView = true) {
            if (!this.dataToBind.hasOwnProperty(fieldName)) return;
            let data = {}
            data[fieldName] = this.dataToBind[fieldName]

            if (bindForView) {
                this.setDisplayData(data);
            } else {
                this.setModelData(data)
            }
        },
        resetField(fieldName) {
            this.fields[fieldName].field.field_value = ''
            this.fields[fieldName].field.updateValue()
            this.fields[fieldName].field.validateMessage = ''
        },
        bindController() {
            if (this.bindingForView) {
                this.setDisplayData(this.dataToBind);
            } else {
                this.setModelData(this.dataToBind)
            }
        },
        arefieldsValid() {
            for (let field in this.fields) {
                if (this.fields[field].field.validateMessage) {
                    this.validData = false;
                    return false;
                }
            }
            this.validData = true;
            return true;
        },
        setfieldsErrorMessage(params, callback) {
            let fieldsErrors = params.fieldsErrors;
            for (let field in fieldsErrors) {
                W_LOGGER('CONTROLLER', this.controllerName, field, this.fields.hasOwnProperty(field))
                if (this.fields.hasOwnProperty(field)) {
                    this.fields[field].field.validateMessage = this.$ml.get(this.makeTextTranslatable(fieldsErrors[field]), fieldsErrors[field]);
                }
            }
            if (callback) {
                callback()
            }
        },
        makeTextTranslatable(text) {
            return String(text).toLowerCase().replace(/\s/g, '_').replace('.', '')
        },
        updateFieldValue(params) {
            if (this.validateField(params)) {
                let dataParent = params.field.dataParent
                let dataParentType = params.field.dataParentType
                let fieldValue = params.field.field_value

                if (dataParent) {
                    if (!this.dataModel.hasOwnProperty(dataParent)) {
                        if (dataParentType == 'object') {
                            this.dataModel[dataParent] = {}
                        }

                        if (dataParentType == 'array') {
                            this.dataModel[dataParent] = []
                        }
                    }

                    if (dataParentType == 'object') {
                        this.dataModel[dataParent][params.field.dataNameInParent] = fieldValue
                    }

                    if (dataParentType == 'array') {
                        this.dataModel[dataParent].push(fieldValue)
                    }
                } else {
                    this.dataModel[params.field.name] = fieldValue
                }

                if (this.dataContainer) {
                    this.dataContainer.$emit('updateFieldValue', {
                        field: params.field
                    })
                }
            }
        },
        standaloneFieldValidate(field, rules) {
            field.field.validateMessage = null;
            if (rules == null) {
                return true;
            }

            rules = rules.split('|');
            if (rules.indexOf('required') != -1 && (field.field.field_value === '' || field.field.field_value == null || field.field.field_value.length === 0)) {
                W_LOGGER('Field Controller | ', 'ERROR IN ' + field.controllerName + ' Field | ', 'Rule Name: Required |', ' Field Value: ' + field.field.field_value);
                field.field.validateMessage = this.$ml.get('this_field_is_required');
                return false;
            }

            return true;
        },
        validateField(field) {
            field.field.validateMessage = null;
            let rules = field.field.rules;
            if (rules == null) {
                return true;
            }

            rules = rules.split('|');
            if (rules.indexOf('required') != -1 && (field.field.field_value === '' || field.field.field_value == null || field.field.field_value.length === 0)) {
                W_LOGGER('Field Controller | ', 'ERROR IN ' + field.controllerName + ' Field | ', 'Rule Name: Required |', ' Field Value: ' + field.field.field_value);
                field.field.validateMessage = this.$ml.get('this_field_is_required');
                this.validData = false;
                return false;
            }
            if (rules.indexOf('optional') != -1 && field.field.field_value == null) {
                return false;
            }

            return true;
        },
        validateFields() {
            return new Promise((resolve, reject) => {
                this.validData = true;
                for (let field in this.fields) {
                    this.validateField(this.fields[field])
                }
                resolve(this.validData)
            })
        },
        registerField(params) {
            this.fields[params.field.name] = {
                field: params.field,
                name: params.field.name
            }
        },
        resetModalData() {
            let inputField = null;
            for (let field in this.fields) {
                inputField = this.fields[field].field;
                if (inputField.binding === 'select') {
                    inputField.setValue(
                        inputField.bindingValues['']
                    );
                    continue;
                }

                let binding = inputField.binding;
                if (binding === 'image') {
                    inputField.imageUrl = ''
                } else if (binding === 'checkbox') {
                    inputField.field_value = ''
                } else {
                    inputField.setValue('');
                }
            }
        },
        setModelData(data) {
            let inputField = null;
            for (let field in data) {
                if (this.fields.hasOwnProperty(field) && data[field] !== null) {
                    inputField = this.fields[field].field;
                    if (inputField.binding === 'select') {
                        if (inputField.multiple || inputField.allowCreate) {
                            inputField.setValue(data[field])
                        } else {
                            inputField.setValue(
                                inputField.bindingValues[data[field]][inputField.valueProperty]
                            );
                        }
                        continue;
                    }

                    let binding = inputField.binding;

                    if (binding === 'string' || binding == 'radio') {
                        inputField.setValue(data[field]);
                    } else if (binding === 'storage-upload') {
                        inputField.setFile(data[field]);
                    } else if (binding === 'image') {
                        inputField.setImageUrl(data[field]);
                    } else if (binding === 'files-list') {
                        inputField.filesList = data[field]
                    } else if (binding === 'checkbox') {
                        inputField.field_value = data[field]
                    }
                }
            }
        },
        setDisplayData(data) {
            let inputField = null;
            for (let field in data) {
                if (this.fields.hasOwnProperty(field) && data[field] !== null) {
                    inputField = this.fields[field].field;
                    if (inputField.binding === 'select') {
                        // for multivalue
                        if (data[field].constructor === Object || data[field].constructor === Array) {
                            let values = []
                            let len = data[field].length;
                            for (let i = 0; i < len; i = i + 1) {
                                // for newly added values that needs
                                if (!inputField.bindingValues.hasOwnProperty(data[field][i])) {
                                    values.push(data[field][i])
                                } else {
                                    values.push(inputField.bindingValues[data[field][i]][inputField.valueProperty])
                                }
                            }
                            inputField.field_value = values
                        } else {
                            inputField.field_value = inputField.bindingValues[data[field]][inputField.valueProperty];
                        }
                        continue;
                    }

                    let binding = inputField.binding;
                    if (binding === 'string' || binding == 'radio') {
                        inputField.field_value = data[field];
                    }  else if (binding === 'storage-upload') {
                        inputField.setFile(data[field]);
                    } else if (binding === 'image') {
                        inputField.setImageUrl(data[field]);
                        continue;
                    } else if (binding === 'files-list') {
                        inputField.filesList = data[field]
                    } else if (binding === 'checkbox') {
                        if (data[field].constructor === Array) {
                            inputField.field_value = data[field]
                        } else {
                            inputField.field_value = [data[field]]
                        }
                    }
                }
            }
        }
    }
};

export default fieldController
